import type { FeatureStates } from '../featureStates';

export function userHasModule(moduleId: string, featureStates: FeatureStates): boolean {
  switch (moduleId) {
    case 'ASSETS':
      return featureStates.assets;
    case 'DATA':
      return featureStates.data;
    case 'SUBSTANCES':
      return featureStates.substances;
    case 'ISSUES':
      return featureStates.issues;
    case 'RISK':
      return featureStates.risk;
    case 'MEETINGS':
      return featureStates.meetings;
    case 'STAFFING':
      return featureStates.staffing;
    case 'HEALTHCARE':
      return featureStates.healthcare;
    case 'NORENGROS':
    case 'NORENGROS-NEW':
    case 'NORENGROS-EXISTING':
      return featureStates.norengros;
    case 'SIGNAGE':
      return featureStates.signage;
  }
  return false;
}
